import React from 'react';
import Calender from './calender-cyao';

const CalenderView = (props) => {
  return (
    <div className="calendar-view">
      <div className="row">
        <div className="column small-12">
          <Calender />
        </div>
      </div>
    </div>
  )
}

export default CalenderView;



// WEBPACK FOOTER //
// ./src/components/itinerary/details/components/calender-view.js